import React from "react";
import { useTranslation } from 'react-i18next';

export default function ClipTitle(props){
    const { t } = useTranslation();
    return(
        <tr>
            <td className='title title-single' colSpan="6" style={{height:"25px", fontSize:"12px",textAlign:"center", padding:"8px"}}>
                <span className='game-info'>
                    [ {props.playInfo.gameDay} &nbsp;
                    {props.useLang === "en" ? props.playInfo.pitcherTeamShortName : props.playInfo.pitcherTeamName}: 
                    {props.useLang === "en" ? props.playInfo.batterTeamShortName : props.playInfo.batterTeamName} ]
                </span>
                &nbsp;
                <span className="turn-info">
                    {props.playInfo.inning} 
                    {t('inning')}
                    {props.playInfo.inningTb == 0 ? t('top') : t('bottom')}
                    &nbsp;
                    {props.playInfo.batInningTurn}{t('turn')} &nbsp;
                </span>
                <span className='player-info'>
                    {props.useLang === "en" 
                        ? (props.playInfo.pitcherForeignerYn == 'Y' ? props.playInfo.pitcherLastName : props.playInfo.pitcherLastName + " " + props.playInfo.pitcherShortName) 
                        : props.playInfo.pitcherName
                    }
                    ({props.playInfo.pitchingHand})
                    vs.
                    {props.useLang === "en" 
                        ? (props.playInfo.batterForeignerYn == 'Y' ? props.playInfo.batterLastName : props.playInfo.batterLastName + " " + props.playInfo.batterShortName) 
                        : props.playInfo.batterName
                    }
                    ({props.playInfo.battingHand})
                </span>
            </td>
        </tr>
    )
}